






































import { Component, Vue, Watch } from 'vue-property-decorator';
import { addMonths, addYears, format, startOfMonth, startOfYear, subMonths, subYears } from '@/filter/dateFormat';
import MonthPicker from '@/components/form/MonthPicker.vue';
import merge from 'lodash.merge';
import { darkTheme } from '@/plugins/highcharts';

interface Options {
  chart: { type: string };
  title: { text: string };
  tooltip: { crosshairs: boolean, pointFormat: string, shared: boolean };
  plotOptions: { line: { dataLabels: { enabled: boolean } } };
  xAxis: { categories: string[], labels: { rotation: number } };
  yAxis: { min: number, title: { text: string } };
  series: Array<{ name: string, data: { y: number, formatted: string } }>;
  colors: string[];
}

@Component({
  components: { MonthPicker }
})
export default class TimeAllocation extends Vue {
  waiting: boolean = false;

  start: string = format(subMonths(startOfMonth(Date.now()), 2), 'yyyy-MM');
  end: string = format(addMonths(startOfMonth(Date.now()), 10), 'yyyy-MM');

  options: Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: 'Statistik: Betreuerstunden'
    },
    tooltip: {
      crosshairs: true,
      pointFormat: '<span style="color:{point.color}">\u25CF</span>{series.name}: <b>{point.formatted} Stunden</b><br/>',
      shared: true
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true
        }
      }
    },
    xAxis: {
      categories: [],
      labels: {
        rotation: -45
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Stunden'
      }
    },
    series: [],
    colors: ['#b71c1c', '#92c3ff', '#ff9c43', '#3fdd7c', '#9b1fdd', '#d97bdd']
  };

  validEnd(value: string): boolean {
    return this.start < value && format(addYears(Date.now(), 1), 'yyyy-MM') >= value;
  }

  validStart(value: string): boolean {
    return this.end > value && format(subYears(startOfYear(Date.now()), 2), 'yyyy-MM') <= value;
  }

  get allOptions() {
    if (!this.$vuetify.theme.dark) {
      return this.options;
    }

    return merge(darkTheme(), this.options)
  }

  @Watch('start')
  onStart() {
    return this.fetch();
  }

  @Watch('end')
  onEnd() {
    return this.fetch();
  }

  created() {
    return this.fetch();
  }

  async fetch() {
    const response = await this.$http.get('api/statistic/time-allocation', {
      responseType: 'json',
      params: { start: `${this.start}-01`, end: `${this.end}-01` }
    });

    this.options.series = [];
    this.options.xAxis.categories = [];

    const { months, ...conservators } = response.data;

    this.options.xAxis.categories = months.map((month: string) => format(month, 'MMMM yyyy'));

    for (const conservator in conservators) {
      if (!conservators.hasOwnProperty(conservator)) continue;

      this.options.series.push({
        name: conservator.split('/')[0],
        data: conservators[conservator].map((hours: number) => ({
          y: hours,
          formatted: hours.toFixed(2)
        }))
      });
    }

    setTimeout(() => {
      this.waiting = true;
    }, 500);
  }
}
